import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllFeatures } from "@/api/new-api/feature";

// Async thunk to fetch all features
export const fetchAllFeatures = createAsyncThunk(
  "features/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllFeatures();
      if (response.status === "success") {
        return response.data.features || [];
      } else {
        return rejectWithValue(response.message || "Failed to fetch features.");
      }
    } catch (error) {
      console.error("Error fetching features:", error);
      return rejectWithValue(error?.message || "Something went wrong.");
    }
  }
);

const allFeaturesSlice = createSlice({
  name: "features",
  initialState: {
    features: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetFeatures: (state) => {
      state.features = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFeatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.features = action.payload;
      })
      .addCase(fetchAllFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFeatures } = allFeaturesSlice.actions;

export default allFeaturesSlice.reducer;
